import cx from 'classnames'
import Styles from './FromURL.module.scss'
import { Button } from 'components/Button'
import { ReactComponent as Blaze } from './images/blaze.svg'
import { ReactComponent as Tentree } from './images/tentree.svg'
import { ReactComponent as MailChimpLogo } from './images/mailchimp.svg'
import { ExampleCard } from './ExampleCard'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useIsUrlCrawlable } from 'hooks/useIsUrlCrawlable'
import { Heading } from 'blaze-ui/Heading/Heading'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export type FromURLProps = {
  examplesVisible?: boolean
  sampleText: string
  onChange: (sampleText: string) => void
  setExamplesVisible?: (value: boolean) => void
  type?: 'campaign' | 'voice'
  showExamples?: boolean
}

export const FromURL: React.FC<React.PropsWithChildren<FromURLProps>> = ({
  sampleText,
  examplesVisible,
  setExamplesVisible,
  onChange,
  type = 'campaign',
  showExamples,
}) => {
  const { isValid, errorMessage } = useIsUrlCrawlable(sampleText)
  const { isMobile } = useResponsiveDesign()
  return (
    <>
      <div className={Styles.headingContainer}>
        <Heading level={5}>Paste a website URL to pull sample contents from</Heading>
      </div>
      <Input
        value={sampleText}
        onChange={(e) => onChange(e.currentTarget.value)}
        size="xl"
        name="sampleText"
        autoCapitalize="off"
        data-onboarding-step-id={`source-url-${type}`}
        placeholder="Enter the URL of your brand’s homepage (“apple.com”)"
        errorMessage={errorMessage}
        validMessage={sampleText.length > 0 && isValid ? 'Looks like a valid URL!' : undefined}
        isValid={isValid}
        aria-label="Source website"
      />
      {showExamples && (
        <>
          <div className={cx(Styles.showExamplesContainer, { [Styles.hidden]: !examplesVisible })}>
            <Heading level={5}>
              {type === 'campaign'
                ? 'Use these types of content to create a great campaign'
                : 'Examples of websites to create a great brand voice from:'}
            </Heading>
            <div className={Styles.examplesContainer}>
              <ExampleCard
                onSelect={onChange}
                text="About us page"
                logo={<Tentree />}
                url="https://www.tentree.com/pages/about"
              />
              <ExampleCard
                onSelect={onChange}
                text="Landing page"
                logo={<MailChimpLogo />}
                url="https://mailchimp.com/"
              />
              {!isMobile && (
                <ExampleCard
                  onSelect={onChange}
                  text="Blog post"
                  logo={<Blaze />}
                  url="https://www.blaze.ai/blog/document-your-journey"
                />
              )}
            </div>
          </div>

          <div className={cx(Styles.showMeContainer, { [Styles.hidden]: examplesVisible })}>
            <Button size="md" variant="tertiary" onPress={() => setExamplesVisible?.(true)}>
              Show Me Examples
            </Button>
          </div>
        </>
      )}
    </>
  )
}
